import React from "react";
import { Flex, Icon, Link, Button } from "@chakra-ui/react";
import { FaFacebook, FaGithub, FaLinkedin, FaWhatsapp } from "react-icons/fa";

const SocialIcons = (): JSX.Element => {
  const socialMediaLinks = [
    {
      icon: FaLinkedin,
      url: "https://www.linkedin.com/in/manishparui/",
    },
    {
      icon: FaGithub,
      url: "https://github.com/manishparui",
    },
    {
      icon: FaWhatsapp,
      url: "https://api.whatsapp.com/send?phone=919804307030",
    },
    {
      icon: FaFacebook,
      url: "https://www.facebook.com/ParuiManish/",
    },
  ];

  return (
    <Flex gap={6}>
      {socialMediaLinks.map((socialMediaLink) => (
        <Button
          key={socialMediaLink.url}
          as={Link}
          variant={"link"}
          color={"neonDefault"}
          href={socialMediaLink.url}
          isExternal={true}
        >
          <Icon as={socialMediaLink.icon} fontSize={"3xl"} />
        </Button>
      ))}
    </Flex>
  );
};

export default SocialIcons;
